(() => {
  const applyFilter = (root, filter) => {
    if (!root) return;
    root.querySelectorAll('[data-srx-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.srxFilter === filter)));
    root.querySelectorAll('[data-category]').forEach(card => { card.hidden = filter !== 'all' && card.dataset.category !== filter; });
  };
  const hashFilter = () => {
    const filter = location.hash.replace('#shop-', '');
    if (filter === 'everyday' || filter === 'sport') {
      const root = document.querySelector('[data-srx-collection]');
      applyFilter(root, filter);
      root?.scrollIntoView({block:'start'});
    }
  };
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('#menu-drawer a[href]');
    if (link && !event.defaultPrevented && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && event.button === 0 && (!link.target || link.target === '_self') && !link.hasAttribute('download')) {
      const destination = new URL(link.href, location.href);
      const drawer = link.closest('header-drawer');
      const details = drawer?.querySelector('details');
      const summary = details?.querySelector('summary');
      if (destination.origin === location.origin && destination.pathname === location.pathname && destination.search === location.search && destination.hash && details?.open && summary && typeof drawer.closeMenuDrawer === 'function') {
        drawer.closeMenuDrawer(event, summary);
        summary.setAttribute('aria-expanded', 'false');
      }
    }
    const button = event.target.closest('[data-srx-filter]');
    if (button) applyFilter(button.closest('[data-srx-collection]'), button.dataset.srxFilter);
    const more = event.target.closest('[data-action="moments"]');
    if (more) {
      const expanded = more.getAttribute('aria-expanded') !== 'true';
      more.setAttribute('aria-expanded', String(expanded));
      more.closest('.srx-moments').classList.toggle('srx-all-moments', expanded);
    }
  });
  const closePromises = except => {
    document.querySelectorAll('.srx-promise[open]').forEach(item => {
      if (item === except) return;
      item.open = false;
      delete item.dataset.hoverOpened;
    });
  };
  const hoverPromises = window.matchMedia('(min-width:750px) and (hover:hover) and (pointer:fine)');
  document.addEventListener('click', event => {
    const item = event.target.closest('.srx-promise');
    closePromises(item);
    if (item?.dataset.hoverOpened && event.target.closest('summary')) {
      event.preventDefault();
      delete item.dataset.hoverOpened;
    }
  });
  document.addEventListener('toggle', event => {
    if (event.target.matches('.srx-promise') && event.target.open) closePromises(event.target);
  }, true);
  document.addEventListener('keydown', event => { if (event.key === 'Escape') closePromises(); });
  document.addEventListener('pointerover', event => {
    const item = event.target.closest('.srx-promise');
    if (hoverPromises.matches && item && event.pointerType === 'mouse' && !item.contains(event.relatedTarget) && !item.open) {
      closePromises(item); item.open = true; item.dataset.hoverOpened = 'true';
    }
  });
  document.addEventListener('pointerout', event => {
    const item = event.target.closest('.srx-promise');
    if (item && event.pointerType === 'mouse' && !item.contains(event.relatedTarget) && item.dataset.hoverOpened) { item.open = false; delete item.dataset.hoverOpened; }
  });
  window.addEventListener('hashchange', hashFilter);
  document.addEventListener('shopify:section:load', hashFilter);
  hashFilter();
})();
